;
export const localeMessage = {
  en: {
    thirdPartyWarehousePushTime: `Third Party Warehouse Push Time`,
    thirdPartyWarehouseReceiveTime: `Third Party Warehouse Receive Time`,
    thirdPartyNumber: `Third Party Number`,
    associatedOutboundNumber: `Associated Outbound Number`
  },
  zh: {
    thirdPartyWarehousePushTime: `\u63A8\u9001\u4E09\u65B9\u4ED3\u65F6\u95F4`,
    thirdPartyWarehouseReceiveTime: `\u63A5\u6536\u4E09\u65B9\u4ED3\u65F6\u95F4`,
    thirdPartyNumber: `\u4E09\u65B9\u5355\u53F7`,
    associatedOutboundNumber: `\u5173\u8054\u51FA\u5E93\u5355\u53F7`
  },
  id: {
    thirdPartyWarehousePushTime: `Waktu Push Gudang Pihak Ketiga`,
    thirdPartyWarehouseReceiveTime: `Waktu Terima Gudang Pihak Ketiga`,
    thirdPartyNumber: `Nomor Pihak Ketiga`,
    associatedOutboundNumber: `Nomor Outbound Terkait`
  },
  th: {
    thirdPartyWarehousePushTime: `\u0E40\u0E27\u0E25\u0E32\u0E17\u0E35\u0E48\u0E14\u0E31\u0E19\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32Third Party`,
    thirdPartyWarehouseReceiveTime: `\u0E40\u0E27\u0E25\u0E32\u0E23\u0E31\u0E1A\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32Third Party`,
    thirdPartyNumber: `\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02Third Party`,
    associatedOutboundNumber: `\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D\u0E02\u0E32\u0E2D\u0E2D\u0E01\u0E17\u0E35\u0E48\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E02\u0E49\u0E2D\u0E07`
  },
  vn: {
    thirdPartyWarehousePushTime: `Th\u1EDDi gian \u0111\u1EA9y h\xE0ng kho b\xEAn th\u1EE9 ba`,
    thirdPartyWarehouseReceiveTime: `Kho b\xEAn th\u1EE9 3`,
    thirdPartyNumber: `M\xE3 h\xE0ng kho b\xEAn th\u1EE9 3`,
    associatedOutboundNumber: `M\xE3 \u0111\u01A1n xu\u1EA5t kho li\xEAn quan`
  }
};
